import {ContextMenu} from "./context-menu";
import {ContextMenuActionCallback} from "./context-menu-types";

export class ContextMenuItem {

  label: string;
  actionCallback: ContextMenuActionCallback;
  labelSuffix: string;
  prefixIcon: string;
  childMenu: ContextMenu;
  isSeparator: boolean;

  constructor(label: string, actionCallback: ContextMenuActionCallback, labelSuffix: string, prefixIcon: string, isSeparator?: boolean) {
    this.label = label;
    this.actionCallback = actionCallback;
    this.labelSuffix = labelSuffix;
    this.prefixIcon = prefixIcon;
    this.isSeparator = isSeparator !== undefined ? isSeparator : false;
  }

  withChildMenu(childMenu: ContextMenu) {
    this.childMenu = childMenu;
    return this;
  }
}
